export const ExternalProps = {
  // MUI
  MuiAlert: "MUI Alert",
  MuiAutocomplete: "MUI Autocomplete",
  MuiCheckbox: "MUI Checkbox",
  MuiDialog: "MUI Dialog",
  MuiLink: "MUI Link",
  MuiMenuItem: "MUI MenuItem",
  MuiOutlinedInput: "MUI OutlinedInput",
  MuiPagination: "MUI Pagination",
  MuiPopover: "MUI Popover",
  MuiRadioGroup: "MUI RadioGroup",
  MuiRating: "MUI Rating",
  MuiSelect: "MUI Select",
  MuiSnackbar: "MUI Snackbar",
  MuiSwitch: "MUI Switch",
  MuiTable: "MUI Table",
  // MUI X
  MuiDatePicker: "MUI DatePicker",
  MuiDateTimePicker: "MUI DateTimePicker",
  MuiTimePicker: "MUI TimePicker",
  MuiTreeView: "MUI TreeView",
} as const;

type ExternalPropsKeys = keyof typeof ExternalProps;
type ExternalPropsValues = (typeof ExternalProps)[ExternalPropsKeys];

export const MUI_API_URL = "https://mui.com/material-ui/api";
export const MUI_X_API_URL = "https://mui.com/x/api";

export const ExternalPropsUrl: Record<ExternalPropsValues, string> = {
  // MUI
  [ExternalProps.MuiAlert]: `${MUI_API_URL}/alert`,
  [ExternalProps.MuiAutocomplete]: `${MUI_API_URL}/autocomplete`,
  [ExternalProps.MuiCheckbox]: `${MUI_API_URL}/checkbox`,
  [ExternalProps.MuiDialog]: `${MUI_API_URL}/dialog`,
  [ExternalProps.MuiLink]: `${MUI_API_URL}/link`,
  [ExternalProps.MuiMenuItem]: `${MUI_API_URL}/menu-item`,
  [ExternalProps.MuiOutlinedInput]: `${MUI_API_URL}/outlined-input`,
  [ExternalProps.MuiPagination]: `${MUI_API_URL}/pagination`,
  [ExternalProps.MuiPopover]: `${MUI_API_URL}/popover`,
  [ExternalProps.MuiRadioGroup]: `${MUI_API_URL}/radio-group`,
  [ExternalProps.MuiRating]: `${MUI_API_URL}/rating`,
  [ExternalProps.MuiSelect]: `${MUI_API_URL}/select`,
  [ExternalProps.MuiSnackbar]: `${MUI_API_URL}/snackbar`,
  [ExternalProps.MuiSwitch]: `${MUI_API_URL}/switch`,
  [ExternalProps.MuiTable]: `${MUI_API_URL}/table`,
  // MUI X
  [ExternalProps.MuiDatePicker]: `${MUI_X_API_URL}/date-pickers/date-picker`,
  [ExternalProps.MuiDateTimePicker]: `${MUI_X_API_URL}/date-pickers/date-time-picker`,
  [ExternalProps.MuiTimePicker]: `${MUI_X_API_URL}/date-pickers/time-picker`,
  [ExternalProps.MuiTreeView]: `${MUI_X_API_URL}/tree-view/tree-view`,
};
